module.exports = __webpack_public_path__ + "img/briefcase-01.1e71092b.svg";